import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import * as Styles from '../assets/_styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const CaseStudiesContainer = styled.div`
  width: 104%;
  margin-left: -2%;
  ${Styles.media.tablet`
    width: 100%;
    margin-left: auto;
  `} display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(4, 1fr);
  flex-direction: column;
  overflow: hidden;
  border-radius: 4px;
  * {
    box-sizing: border-box;
  }
`

const Background = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  height: 248px;
`
const Logo = styled.img`
  filter: brightness(10);
  position: absolute;
  z-index: 2;
  max-width: 240px;
  filter: grayscale(1);
  transition: all 0.1s ease-in-out;
`
const CaseStudyContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  grid-column: span 2;
  &:first-of-type {
    grid-column: span 4;
    ${Info} > ${Subtitle} {
      max-width: 80%;
    }
  }
  ${Background} {
    z-index: 0;
    width: 100%;
    height: 248px;
    > div {
      width: 100%;
      height: 100%;
      min-height: 248px;
      filter: brightness(0.35);
    }
  }

  &:hover {
    ${Logo} {
      filter: grayscale(0);
    }
  }

  ${Styles.media.tablet`
    grid-column: span 4;
  `};
`

const Subtitle = styled.div`
  margin: 16px 0 0;
  line-height: 1.6;
  font-size: 0.9em;
  font-weight: 300;
  color: #666;
`

const ReadMore = Subtitle.extend`
  font-weight: 300;
  svg {
    font-size: 1em;
  }
`

const Info = styled.div`
  bottom: 0;
  z-index: 20;
  position: relative;
  width: 100%;
  background-color: white;

  text-align: left;
  padding: 32px;
  overflow: hidden;
  h6 {
    font-size: 1.2em;
    margin: 0;
  }
`

const CaseStudy = ({ title, subtitle, background, logo, slug, company }) => (
  <CaseStudyContainer>
    <Link to={slug}>
      <Background>
        <Logo src={logo.src} />
        <div>
          <Img sizes={background.childImageSharp.sizes} />
        </div>
      </Background>
    </Link>
    <Info>
      <Link to={slug}>
        <h6>
          {company}: {title}
        </h6>
      </Link>
      <Subtitle>{subtitle}</Subtitle>
      <Link to={slug}>
        <ReadMore>
          Read More <FontAwesomeIcon icon={['fas', 'angle-right']} />
        </ReadMore>
      </Link>
    </Info>
  </CaseStudyContainer>
)

class CaseListing extends Component {
  constructor(props) {
    console.log(props)
    super(props)
  }
  render() {
    return (
      <CaseStudiesContainer>
        {this.props.posts.allMarkdownRemark.edges.map(({ node }) => (
          <CaseStudy
            slug={node.fields.slug}
            company={node.frontmatter.company}
            title={node.frontmatter.title}
            subtitle={node.frontmatter.subtitle}
            logo={node.frontmatter.logo.childImageSharp.original}
            background={node.frontmatter.background}
          />
        ))}
      </CaseStudiesContainer>
    )
  }
}

export default CaseListing

export const query = graphql`
  fragment CaseListingFragment on MarkdownRemark {
    id
    fields {
      slug
    }
    frontmatter {
      title
      subtitle
      company
      logo {
        childImageSharp {
          original {
            src
          }
        }
      }
      background {
        childImageSharp {
          sizes(maxWidth: 1600, quality: 80) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/CaseListing.js